/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AiTutor<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  getHistoryList = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/AiTutor/GetHistory`,
      method: "GET",
      secure: true,
      ...params,
    });
  askCreate = (data: { message: string; subject?: number; context?: string; image?: string }, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/AiTutor/Ask`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
